<div class="preview">
  <formly-form
    [fields]="fields | dictionaryField"
    [form]="form"
    [model]="model"
    [options]="options"
  ></formly-form>
</div>
